<template>
  <div class="rb-ob-form rb-match-page rb-book-page rb-pay-page rb-consent-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.sessionCheckTitle') }}</h1>
    </header>

    <div class="rb-ob-status-panel">
      <p class="rb-match-outcome-body">{{ $t('intake.sessionCheckBody') }}</p>
    </div>

    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" @click="back">
        {{ $t('intake.sessionCheckBack') }}
      </button>
      <p class="rb-ob-status" role="status" aria-live="polite"></p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatchSessionCheckStep',
  methods: {
    back() {
      this.$router.push({
        name: 'intakeReadyOk',
        params: {lang: this.$route.params.lang || 'fa'},
      })
    },
  },
}
</script>
